<div class="row">
    <div class="col-md-6" *ngFor="let fieldParam of listeFieldParam">
        <zone-predefinie-item
            [fieldParam]="fieldParam"            
            [fieldContainer]="fieldContainer"
            [isDisableInactive]="isDisableInactive"
        ></zone-predefinie-item>
    </div>
</div>
